<template>
  <div class="view_card courseWrap">
    <div class="courseWrap_header" v-if="shop.showTitle">
      <span>商城</span>
      <div class="more" v-if="shop.more" @click="more">更多<i class="iconfont icon-right"></i></div>
    </div>
    
    <ul class="courseList" v-if="shop.showType === 0">
      <li class="left" v-for="(vo,i) in shop.filterList" v-if="shop.autoUpdate && i < 6" @click="toShopInfo(vo.generate_url)">
        <div class="imgWrap">
          <van-image fit="cover" :src="vo.img" alt="" lazy-load>
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
          <span v-show="vo.saletype=='1'" class="miaosha">秒杀</span>
        </div>
        <div class="courseList_info">
          <p class="courseList_info-title ellipsis" :title="vo.name">{{vo.name}}</p>
          <p class="explain">非会员{{vo.paynum}}</p>
          <p class="explain">会员{{vo.vippaynum}}</p>
        </div>
      </li>
      <li class="left" v-for="(vo,i) in shop.data" v-if="!shop.autoUpdate" @click="toShopInfo(vo.generate_url)">
        <div class="imgWrap">
          <van-image :src="vo.img" alt="" v-show="vo.img" fit="cover" lazy-load>
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
          <span v-show="vo.saletype=='1'" class="miaosha">秒杀</span>
        </div>
        <div class="courseList_info">
          <p class="courseList_info-title ellipsis">{{vo.name}}</p>
          <p class="explain">非会员{{vo.paynum}}</p>
          <p class="explain">会员{{vo.vippaynum}}</p>
        </div>
        <p class="hint" v-if="!vo.name">请选择商品</p>
      </li>
    </ul>
    <ul class="course_vtc" v-if="shop.showType === 1">
      <li class="shadow" v-for="(vo,i) in shop.filterList" v-if="shop.autoUpdate && i < 6" @click="toShopInfo(vo.generate_url)">
        <div class="topImg">
          <van-image fit="cover" :src="`${vo.img}?x-oss-process=image/resize,m_fill,h_100,w_175`" alt="" lazy-load>
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
          <span v-show="vo.saletype=='1'" class="miaosha">秒杀</span>
        </div>
        <p class="name ellipsis" :title="vo.name">{{vo.name}}</p>
        <p class="age">非会员{{vo.paynum}}</p>
        <p class="age">会员{{vo.vippaynum}}</p>
      </li>
      <li class="shadow" v-for="(vo,i) in shop.data" v-if="!shop.autoUpdate" @click="toShopInfo(vo.generate_url)">
        <div class="topImg">
          <van-image :src="`${vo.img}?x-oss-process=image/resize,m_fill,h_100,w_175`" alt="" v-show="vo.img" fit="cover" lazy-load>
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
          <span v-show="vo.saletype=='1'" class="miaosha">秒杀</span>
        </div>
        <p class="name ellipsis">{{vo.name}}</p>
        <p class="age">非会员{{vo.paynum}}</p>
        <p class="age">会员{{vo.vippaynum}}</p>
        <p class="hint" v-show="!vo.name">请选择商品</p>
      </li>
    </ul>
    <van-empty v-if="shop.data.length === 0 && shop.filterList.length === 0" description="暂无数据"></van-empty>
  </div>
</template>

<script>
import {mapState} from 'vuex'
  export default {
    name: "ShopStore",
    props:['shop'],
    computed:{
      ...mapState({
        orgId:state=>state.orgId
      })
    },
    methods:{
      more(){
        window.location.href = this.shop.moreLink
      },
      toShopInfo(url){
        window.location.href = url
      }
    },
  }
</script>

<style lang="stylus" scoped>
  @import "../static/css/global.styl"
  .courseWrap
    color #333
    padding 10px
    font-size 14px
    flex-direction column
    .noData
      height 40px
    .courseWrap_header
      width 100%
      display flex
      align-items center
      justify-content space-between
      margin 10px 0
      >span
        font-weight 700
        font-size 16px
      .more
        font-size 14px
        color #999
        display flex
        cursor: pointer;
        align-items center
        .iconfont
          line-height 14px
    .courseList
      margin-top 10px
      width 100%
      li
        display flex
        justify-content space-between
        width 100%
        /*height 120px*/
        margin-bottom 14px
        &:last-child
          margin-bottom 0
        >div
          width 50%
          flex-shrink 0
        .imgWrap
          position relative
          height 104px
          overflow hidden
          display flex
          align-items center
          justify-content center
          img
            width auto
            height 100%
          img[lazy='error'],img[lazy='loading']
            width 50px
            height 50px
        .courseList_info
          padding 2px 0 0 10px
          .courseList_info-title
            font-size 15px
            color #666
            font-weight 700
          .explain
            line-height 22px
          .intro
            color #999
            font-size 12px
            line-height 17px
            margin-top 6px
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
    .course_vtc
      display flex
      flex-wrap wrap
      width 100%
      justify-content space-between
      li
        width 175px
        margin-top 10px
        .topImg
          position relative
          width 100%
          height 100px
          overflow hidden
          margin-bottom 4px
          display flex
          align-items center
          justify-content center
          .van-image
            width 100%
            height 100%
          img[lazy='error'],img[lazy='loading']
            width 50px
            height 50px
        .name,.age,.brief
          padding 0 6px
        .age
          color #999
          font-size 12px
          margin 8px 0
        .brief
          margin-bottom 10px
          color #999
          font-size 12px
          line-height 16px
        .ellipsis
          max-width 100%
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
.miaosha
  position absolute
  font-size 12px
  top 5px
  left 5px
  width 40px
  height 15px
  line-height 15px
  text-align center
  border-radius 5px
  color #fff
  background-color #03a9f4
</style>
